<template>
  <div class="template-table">
    <table
      ref="table"
      class="table"
      :id="randomId"
      :class="
        (customClass ? customClass : '') +
        ' ' +
        (for_print ? 'for_print' : min ? 'my_media' : fixed_header ? 'fixed_header' : '')
      "
    >
      <thead>
        <slot name="header">
          <tr :id="'thead_' + randomId">
            <th
              v-for="(item, key) in head"
              :key="key"
              class="text-left"
              @click="item.sort ? onFilterParams(item.sort.name, item.sort.value) : undefined"
            >
              <div style="white-space: pre-line;" :class="{ sorted: item.sort }">
                {{ item.text }}
                <IconSort v-if="item.sort" :param="item.sort.name" />
              </div>
            </th>
          </tr>
        </slot>
      </thead>
      <tbody>
        <slot name="responsive"><slot></slot></slot>
      </tbody>
    </table>
    <div class="width_check_table_breakpoint" v-if="checkOn" :id="'checkTable_' + randomId">
      <table
        class="table"
        :class="
          (customClass ? customClass : '') +
          ' ' +
          (for_print ? 'for_print' : fixed_header ? 'fixed_header' : '')
        "
      >
        <thead>
          <slot name="header">
            <tr>
              <th
                v-for="(item, key) in head"
                :key="key"
                class="text-left"
                @click="item.sort ? onFilterParams(item.sort.name, item.sort.value) : undefined"
              >
                <div style="white-space: pre-line;" :class="{ sorted: item.sort }">
                  {{ item.text }}
                  <IconSort v-if="item.sort" :param="item.sort.name" />
                </div>
              </th>
            </tr>
          </slot>
        </thead>
        <tbody>
          <slot></slot>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import IconSort from 'components/icons/IconSort'

export default {
  name: 'TemplateTable',
  refs: ['table'],
  components: {
    IconSort,
  },
  props: {
    head: Array,
    customClass: [String, Object],
    for_print: Boolean,
    fixed_header: Boolean,
    scrolled: Boolean,
  },
  data: () => ({
    min: false,
    list: null,
    ready: false,
    tableBodys: null,
    element: null,
    checkOn: false,
    tableShowKey: null,
  }),
  mounted() {
    this.$nextTick(() => {
      this.onAllCheck()
    })
  },
  computed: {
    randomId() {
      let min = Math.ceil(1)
      let max = Math.floor(1000)
      return 'table_' + Math.floor(Math.random() * (max - min + 1)) + min
    },
    clientWidth() {
      return this.$vuetify.breakpoint.width
    },
  },
  watch: {
    clientWidth: {
      deep: true,
      handler: function (newData, oldData) {
        if (newData !== oldData) {
          this.onAllCheck()
        }
      },
    },
  },
  updated() {
    this.$nextTick(() => {
      this.toggleAccordionParams()
    })
  },
  beforeDestroyed() {
    this.destroyEvent()
  },
  methods: {
    async onAllCheck() {
      if (!this.for_print) {
        this.checkOn = true
        await this.checkWidth()
        this.toggleAccordionParams()
        this.checkOn = false
        this.tableShowKey = new Date().getTime()
      }
    },
    onFilterParams(paramName, value) {
      if (paramName && value) {
        this.$routerPushQuerySort(paramName, value)
      } else return
    },
    checkWidth() {
      let _this = this
      return new Promise(function (resolve, reject) {
        setTimeout(() => {
          const checkTable = document.getElementById('checkTable_' + _this.randomId)
          if (checkTable) {
            const checkTableWidth = checkTable.offsetWidth
            const parentElement = checkTable.parentElement
            const parentElementWidth = parentElement.offsetWidth
            // console.log('checkTableWidth', checkTableWidth)
            // console.log('parentElementWidth', parentElementWidth)
            if (parentElement === 0) {
              setTimeout(() => {
                _this.min = checkTableWidth > parentElementWidth
                _this.$emit('min', _this.min)
              }, 0)
            } else {
              _this.min = checkTableWidth > parentElementWidth
              _this.$emit('min', _this.min)
            }
          }
          resolve(true)
        }, 0)
      })
    },
    toggleAccordionParams() {
      return new Promise((resolve) =>
        setTimeout(() => {
          const table = document.getElementById(this.randomId)
          if (table) {
            this.tableBodys = table.getElementsByTagName('tbody')
            for (let tb of this.tableBodys) {
              if (tb.children.length) {
                for (let [trKey, trItem] of Object.entries(tb.children)) {
                  if (this.min) {
                    if (trItem.classList && !trItem.classList.contains('listener')) {
                      trItem.classList.add('listener')
                      trItem.firstChild.addEventListener('click', this.toggleListener)
                    }
                    if (trItem.querySelector('.show')) {
                      trItem.classList.add('listener--show')
                    }
                  } else {
                    trItem.classList.remove('listener')
                    trItem.classList.remove('listener--show')
                    trItem.classList.remove('listener--error')
                    trItem.classList.remove('listener--active')
                    trItem.firstChild.removeEventListener('click', this.toggleListener)
                  }
                  // addTableDataTable
                  for (let [tdKey, tdItem] of Object.entries(trItem.children)) {
                    if (!tdItem.hasAttribute('data-title')) {
                      if (this.head && this.head[tdKey] && this.head[tdKey].text) {
                        tdItem.setAttribute('data-title', this.head[tdKey].text)
                      }
                    }
                  }
                }
              }
            }
          }
          resolve(true)
        }, 0),
      )
    },
    destroyEvent() {
      for (let tb of this.tableBodys) {
        if (tb.childNodes.length) {
          for (let item of tb.childNodes) {
            if (item.firstChild) {
              item.firstChild.removeEventListener('click', this.toggleListener)
            }
          }
        }
      }
    },
    toggleListener(item) {
      let target = item.currentTarget.parentElement
      if (!target.classList.contains('listener--error')) {
        target.classList.toggle('listener--active')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.template-table {
  // position: relative;
  //overflow: hidden !important;
  width: 100%;
}

.width_check_table_breakpoint {
  // height: 64px !important;
  // overflow-x: hidden;
  // background-color: #3d8cb7;
  //   left: -999em;
  position: absolute !important;
  // visibility: hidden;
  // position: absolute;
  top: -9999px;
  left: -9999px;

  // thead th {
  //     position: sticky;
  //     top: 0;
  //     background: #fafafa;
  // }
}

.bb {
  border-bottom: 1px solid #d1d1d1;
}

.table_fixed {
  box-shadow: none !important;
  white-space: nowrap;
  :deep() * {
    //color: red !important;
    border-color: transparent !important;
  }
}

:deep().table {
  width: 100%;
  position: relative;

  .v-data-table__wrapper {
    overflow: visible;
  }

  border-collapse: collapse;

  table {
    box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
  }

  &.for_print {
    tbody {
      tr {
        height: 64px;
      }
    }
  }

  &.fixed_header {
    & thead {
      position: sticky;
      top: 115px;
      z-index: 200;
    }
    & tr > th {
      // position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 2;
      background-color: #fafafa;
    }
  }

  thead {
    tr {
      th {
        font-size: 1rem !important;
        font-weight: 500;
        color: #2c2c2c !important;
        div {
          text-align: start;
        }
        .sorted {
          cursor: pointer;
          display: grid;
          grid-template-columns: auto max-content;
          justify-content: flex-start;
          column-gap: 13px;
          align-items: center;
        }
      }

      background: #fafafa;
      border: 1px solid #d1d1d1;
    }
  }

  tbody {
    tr:not(.customTable) {
      background: #f2f2f2;
      border: 1px solid #d1d1d1;

      &:hover {
        background: #ffffff;
      }

      &.blocked {
        background-color: #dbdbdb;
      }
    }
  }

  tr {
    th,
    td:not(.customTable) {
      padding: 10px;
      height: 64px !important;

      &:first-child {
        padding-left: 25px;
      }

      &:last-child {
        padding-right: 25px;
      }
    }

    td {
      font-weight: normal;
      color: #323c47 !important;
      @media only screen and (max-width: 999px) {
        height: auto !important;
      }

      .buttons {
        display: grid;
        // grid-template-columns: repeat(auto-fit, 50px);
        grid-template-columns: repeat(2, 50px);
        height: 100%;
        gap: 5px;
        justify-content: flex-end;
        justify-items: center;
        button {
          display: grid;
          align-items: center;
          justify-content: center;
          position: relative;

          &:hover {
            .arrow-5 {
              display: block;
            }
          }

          &.close_table {
            &:hover {
              :deep() svg {
                path {
                  fill: #ec1b0e;
                }
              }
            }
          }
        }
      }

      .icons {
        width: 100%;
        height: 100%;
        display: grid;
        align-items: center;

        .icon {
          width: max-content;
          height: max-content;
          line-height: 0;
        }
      }
    }
    .group {
      margin: 5px;
      border: 1px solid #277faf;
    }
  }
  .extraHead {
    padding: 10px 0px 10px 25px;
    color: #277faf;
    border-bottom: 1px solid #e3e3e3;
    &--min {
      padding: 10px 0 10px 10px;
    }
  }

  &.my_media {
    padding: 5px;
    border: 1px solid #ccc;
    display: block;
    /* Force table to not be like tables anymore */
    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }
    /* Hide table headers (but not display: none;, for accessibility) */
    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    @keyframes show_td {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    tbody {
      display: grid;
      row-gap: 20px;
      tr {
        border: 1px solid rgb(190, 219, 235);
        background: #ffffff;
        display: grid;
        td {
          /* Behave  like a "row" */
          display: grid;
          align-items: center;
          border: none;
          position: relative !important;

          // padding-left: 50% !important;
          height: auto !important;
          min-height: 64px;
          padding: 15px !important;
          white-space: normal;
          text-align: left;
          width: 100% !important;
          overflow: hidden;
          // grid-template-columns: 30% auto;
          &:not(.listener) {
            display: none;
          }
          .buttons {
            justify-content: space-between !important;
            gap: 20px;
          }

          &:before {
            /* Now like a table header */
            // position: absolute;
            /* Top/left values mimic padding */
            content: attr(data-title);
            display: block;
            // width: 45%;
            top: auto;
            position: static !important;
            height: auto;
            bottom: auto;
            font-size: 0.875rem !important;
            padding-right: 10px;
            margin-bottom: 8px;
            white-space: nowrap;
            text-align: left;
            font-weight: bold;
            background: none;
          }
        }
        &.listener {
          & > td {
            //background-color: blue;
            position: relative;
            cursor: pointer;
            &:first-child {
              display: grid !important;
              padding-right: 60px !important;
              .show {
                position: absolute;
                right: 50px;
              }
              &::after {
                content: url('~@/assets/svg/arrow.svg');
                position: absolute;
                right: 25px;
                top: 50%;
                transform: translateY(-50%);
                transition: 0.3s;
              }
            }
          }
          & > div {
            display: none;
          }
          &--active,
          &--error {
            border: 2px solid #3d8cb7 !important;
            & > td {
              &:not(:first-of-type) {
                display: grid;
                animation-name: show_td;
                animation-duration: 0.3s;
                animation-timing-function: ease-in-out;
                animation-fill-mode: forwards;
              }
              &:not(:last-of-type) {
                border-bottom: 1px solid rgb(190, 219, 235);
              }
              &:first-of-type {
                &::after {
                  transform: translateY(-50%) rotate(90deg);
                }
              }
            }
            & > div {
              display: grid;
              & > td {
                display: grid;
                &:not(:last-of-type) {
                  border-bottom: 1px solid rgb(190, 219, 235);
                }
              }
            }
          }
          &--show {
            & > td {
              &:first-child {
                padding-right: 110px !important;
              }
            }
          }
          &--error {
            border: 2px solid rgb(255, 82, 82) !important;
          }
        }
      }
    }
  }
}
</style>
